import { render } from "./IconPackage.vue?vue&type=template&id=7386f87e"
import script from "./IconPackage.vue?vue&type=script&lang=ts"
export * from "./IconPackage.vue?vue&type=script&lang=ts"
script.render = render

export default script